import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { IconPlus, IconBuildingCommunity } from '@tabler/icons';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';

const Cities = () => {
    const location = useLocation();
    const { stateId } = useParams();
    const [state] = useState(location.state?.state || null);

    const [appId, setAppId] = useState(null);
    const [cities, setCities] = useState([]);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ name: '', ibge_code: '' });

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAppId(res.data.app.id);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        loadCities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    const loadCities = async () => {
        try {
            const res = await api.get(`v1/apps/${appId}/cities/?state=${stateId}`);
            setCities(res.data || []);
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao carregar municípios' });
        }
    };

    const handleSave = async () => {
        try {
            await api.post(`v1/apps/${appId}/cities/`, { ...form, state: stateId });
            setDialogOpen(false);
            setForm({ name: '', ibge_code: '' });
            loadCities();
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao criar município' });
        }
    };

    return (
        <Box>
            <PageHeader
                icon={IconBuildingCommunity}
                gradient="amber"
                title={`Municípios${state ? ` - ${state.name}` : ''}`}
                subtitle="Cidades desse estado"
                actions={
                    <Button variant="contained" startIcon={<IconPlus size={18} />} onClick={() => setDialogOpen(true)}>
                        Novo município
                    </Button>
                }
            />

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <GlassCard>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Código IBGE</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cities.map((city) => (
                                <TableRow key={city.id} hover>
                                    <TableCell>{city.name}</TableCell>
                                    <TableCell>{city.ibge_code || '—'}</TableCell>
                                </TableRow>
                            ))}
                            {cities.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        Nenhum município cadastrado ainda
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </GlassCard>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Novo município</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField label="Nome" fullWidth value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                        <TextField
                            label="Código IBGE (opcional)"
                            fullWidth
                            value={form.ibge_code}
                            onChange={(e) => setForm({ ...form, ibge_code: e.target.value })}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Cities;
